import request from './request'

export const login = (data) => request.post('/admin/auth/login', data)
export const logout = () => request.post('/admin/auth/logout')
export const getInfo = () => request.get('/admin/auth/info')
